import { Grid } from '@material-ui/core';
import { TruncateText, Text, PrimaryButton } from 'library';
import Newsfeed from 'parent-portal/home/newsfeed/Newsfeed';
import { NewsfeedContextProvider } from 'parent-portal/home/newsfeed/NewsfeedContext';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { IGroup } from './models';
import { useMediaQuery } from '@mui/material';
import _ from 'lodash';
import theme from 'theme';
import GroupHeader from './GroupHeader/GroupHeader';
import GroupMembers from './GroupMembers';
import GroupAbout from './GroupAbout';
import { refreshGroup } from './shared/api';
import ProviderHires from './Providers/ProviderHires';
import { isLoggedIn } from 'api/UserApi';
import { client, consoleLogInDev, track } from 'shared';
import { useUserContext } from 'UserContext';

export default function Group() {
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));
    const { id } = useParams<{ id: string }>();
    const [group, setGroup] = useState<IGroup>();
    const [loading, setLoading] = useState(false);
    const { user } = useUserContext();

    useEffect(() => {
        refreshGroup(id, setGroup);
    }, []);

    const about = <TruncateText text={group?.description || ''} />;

    function onJoinPress() {
        track('Groups: Join button clicked');
        client('api/group-relation/', { method: 'POST', body: { user_id: user?.id, group_id: group?.id } })
            .then((response) => {
                track('Groups: User added to group', { group: group?.name, user: user?.id });
                refreshGroup(id, setGroup);
            })
            .catch((error) => {
                consoleLogInDev(error);
                track('Groups: Error adding user to group', { group: group?.id, user: user?.id });
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>
            <Grid xs={12} style={{ marginLeft: 25, marginRight: 25 }}>
                {group ? (
                    <>
                        <GroupHeader group={group} about={about} />
                        <Grid xs={12} container item direction="row">
                            <Grid
                                xs={12}
                                lg={3}
                                direction="column"
                                container
                                item
                                style={{ paddingRight: mdDown ? 0 : 25 }}
                            >
                                <GroupAbout about={about} />
                                <GroupMembers groupId={id} group={group} />
                                {mdDown ? <ProviderHires groupId={group.id} /> : <></>}
                            </Grid>
                            <NewsfeedContextProvider groupId={parseInt(id)}>
                                <Grid xs={12} lg={6} container item direction="column" style={{ paddingBottom: 25 }}>
                                    {group?.is_member ? (
                                        <Newsfeed />
                                    ) : isLoggedIn() ? (
                                        <>
                                            <Text variant="body1" textStyle={{ textAlign: 'center' }}>
                                                This is a private group, join to see content.
                                            </Text>
                                            <PrimaryButton
                                                loading={loading}
                                                onClick={onJoinPress}
                                                buttonStyle={{
                                                    marginTop: 24,
                                                    width: '80%',
                                                    maxWidth: 200,
                                                    alignSelf: 'center',
                                                }}
                                            >
                                                Join
                                            </PrimaryButton>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </Grid>
                            </NewsfeedContextProvider>
                            {mdDown ? null : (
                                <Grid
                                    xs={12}
                                    lg={3}
                                    direction="column"
                                    container
                                    item
                                    style={{ paddingLeft: mdDown ? 0 : 25 }}
                                >
                                    <ProviderHires groupId={group.id} />
                                </Grid>
                            )}
                        </Grid>
                    </>
                ) : (
                    <></>
                )}
            </Grid>
        </>
    );
}
